export function FacebookLogoSidebar() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.99999 0C15.5228 0 20 4.47716 20 9.99999C20 15.1127 16.1629 19.3287 11.2115 19.9267V13.0558L13.9167 13.0558L14.4779 10H11.2115V8.91924C11.2115 8.11181 11.3699 7.55282 11.7332 7.19569C12.0966 6.83855 12.6649 6.68327 13.4848 6.68327C13.6923 6.68327 13.8833 6.68534 14.0527 6.68947C14.2992 6.69547 14.5002 6.70584 14.64 6.72056V3.9504C14.5841 3.93487 14.5181 3.91934 14.4442 3.90405C14.2767 3.86942 14.0685 3.83603 13.8447 3.80672C13.377 3.74544 12.8411 3.70192 12.4662 3.70192C10.952 3.70192 9.80767 4.02585 9.00891 4.69682C8.0449 5.50659 7.58423 6.82185 7.58423 8.68323V9.99999H5.52216V13.0558H7.58423V19.7055C3.2286 18.6249 0 14.6898 0 9.99999C0 4.47716 4.47716 0 9.99999 0Z"
        fill="hsl(var(--base-sidebar-foreground))"
      />
    </svg>
  )
}
